import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  CloseIcon, TagContainer, TagLabel, Label
} from './styled';

const Tag = ({
  showDelete, value, onDelete, type, valSelected, filterKey, customAttributes, isOneOf = false
}) => {
  const isDate = type === 'val' && filterKey.toLowerCase().includes('date');
  const isCustomField = type === 'key' && filterKey.toLowerCase().includes('custom_field');
  const label = isCustomField ? customAttributes.find((cf) => cf.field_name === value.split('->')[1]).field_display_name : '';
  const isOneOfVal = type === 'val' && isOneOf;

  const valueParsed = () => {
    if (isDate) return moment(value).format('L');
    else if (isCustomField) return label;
    else if (isOneOfVal) return value.split(',');
    else return value;
  };
  if (!value) return null;
  return (
    <TagContainer type={ type } valSelected={ valSelected } isOneOf={ isOneOf }>
    { isOneOfVal
      ? valueParsed()?.map((v, i) => <Label key={ `filter_value__${value}_${i}` }>{ v }</Label>)
      : <TagLabel type={ type } >
          {valueParsed()}
        </TagLabel>
    }
    { showDelete && <CloseIcon onClick={ onDelete } isOneOfVal={ isOneOfVal } />}
    </TagContainer>
  );
};

export default Tag;

Tag.propTypes = {
  showDelete: PropTypes.bool,
  type: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  value: PropTypes.string,
  filterKey: PropTypes.string
};

Tag.defaultProps = {
  onDelete: null,
  showDelete: false,
  value: '',
  filterKey: ''
};
